module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_SE-ebf22d1698fe29ababd945b47e53fee8.svg";